import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Cleave from '../../../components/UI/CustomInputField/CustomCleaveField';
import Constants from '../FundingAccount/constants.ts';
import WidgetPropTypes from '../types';
import css from './FundWallet.module.scss';

const {
  PLAID_RULES: { maximum }
} = Constants;

export const WIDGET_NAME = 'set_initial_funding_amount';
export function MINIMUM_ERROR_MESSAGE(minimum) {
  return `Please choose an initial amount of $${minimum} or more`;
}
export const MAXIMUM_ERROR_MESSAGE = `Please choose an initial load amount less than or equal to $${maximum}.`;

class FundWallet extends Component {
  state = {
    customAmountError: false,
    customAmountErrorMessage: '',
    presetAmount: undefined,
    amount: undefined,
    settingCustom: false
  };

  presetAmounts =
    this.props.toggles.walletMinimum.shouldShift &&
    this.props.toggles.walletMinimum.displayAmount < 20 &&
    this.props.toggles.walletMinimum.displayAmount > 0
      ? [this.props.toggles.walletMinimum.displayAmount, 20, 50, 'custom']
      : [20, 50, 100, 'custom'];

  componentDidMount() {
    const { shouldEnable, widget } = this.props;
    this.props.analytics.trackEvent('Registration Initial Funding Viewed');

    this.props.analytics.trackEvent('Feature Toggle Decided', {
      eventProps: {
        feature_key: 'acquisition_parentFundWalletDesign',
        variation_key: this.props.toggles.parentFundWalletDesign.variationKey,
        toggle_enabled: this.props.toggles.parentFundWalletDesign.enabled,
        experiment_key: 'acquisition_parentFundWalletDesign_test'
      }
    });

    if (!this.state.amount) {
      shouldEnable(widget, false);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { shouldEnable, widget, changeAnswerValue } = this.props;
    if (this.state !== prevState) {
      shouldEnable(widget, !!this.state.amount);
      changeAnswerValue(widget, this.state.amount);
    }
  }

  errorChecking = async () => {
    if (this.state.amount < this.props.toggles.walletMinimum.amount) {
      this.setState({
        customAmountError: true,
        customAmountErrorMessage: MINIMUM_ERROR_MESSAGE(
          this.props.toggles.walletMinimum.amount
        )
      });
      throw new Error();
    }
    if (this.state.amount > maximum) {
      this.setState({
        customAmountError: true,
        customAmountErrorMessage: MAXIMUM_ERROR_MESSAGE
      });
      throw new Error();
    }
    this.setState({
      customAmountError: false,
      customAmountErrorMessage: ''
    });
    return false;
  };

  render() {
    return (
      <div className={css.FundWallet} onClick={this.props.onClick}>
        <div className={css.FundWalletButtonGroup}>
          {this.presetAmounts.map(presetAmount => {
            const active = this.state.presetAmount === presetAmount;
            const isCustom = presetAmount === 'custom';
            return (
              <button
                key={presetAmount}
                data-e2e={`funding-${presetAmount}`}
                className={`${css.button} ${active ? css.active : ''}`}
                onClick={() => {
                  this.setState({
                    presetAmount,
                    settingCustom: isCustom,
                    amount: isCustom ? undefined : presetAmount
                  });
                }}
              >
                {isCustom ? 'Custom' : `$${presetAmount}`}
              </button>
            );
          })}
        </div>
        <div className={css.FundWalletForm} autoComplete="off">
          {this.state.settingCustom && (
            <Cleave
              options={{
                prefix: '$',
                rawValueTrimPrefix: true,
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
                numeralDecimalScale: 2,
                numeralPositiveOnly: true
              }}
              inputMode="numeric"
              pattern="[0-9\.]*"
              rawValue={true}
              error={this.state.customAmountError}
              format={this.state.customAmountErrorMessage}
              onChange={value =>
                this.setState({
                  amount: value ? parseFloat(value) : undefined
                })
              }
              data-e2e="custom-funding-amount"
              data-testid="custom-funding-amount"
              allowFullStory={true}
            />
          )}
        </div>
      </div>
    );
  }
}

FundWallet.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default FundWallet;
